/** @jsx jsx */
import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { css, styled, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

/* translate3d forces Safari to use hardware acceleration. This will avoid flickering and ghosts */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const AnimatedBox = styled.div({
	borderBottom: 'none',
	zIndex: '12',
	backgroundColor: token('elevation.surface'),
	marginLeft: '-10px',
	paddingLeft: '10px',
	paddingBottom: '10px',
	width: 'inherit',
});

const wrapperStyle = css({ zIndex: '10', position: 'initial' });

export class StickyWrapper extends PureComponent {
	static propTypes = {
		createAnalyticsEvent: PropTypes.func.isRequired,
		children: PropTypes.node,
	};

	getHeaderComponent() {
		const { children } = this.props;
		if (children && React.Children.only(children)) {
			return children;
		}
		return null;
	}

	cloneHeader() {
		const header = this.getHeaderComponent();
		if (!header) {
			return null;
		}

		const cloneProps = {
			className: `${header.props.className || ''} sticky-header`,
			isSticky: true,
			style: { backgroundColor: token('elevation.surface') },
		};
		return cloneElement(header, cloneProps);
	}

	render() {
		return (
			<div
				css={wrapperStyle}
				ref={this.containerRef}
				data-testid="with-sticky-header"
				data-vc="sticky-wrapper-css-container"
			>
				<AnimatedBox data-test-id="header-animated-box" data-vc="header-animated-box">
					{this.cloneHeader()}
				</AnimatedBox>
			</div>
		);
	}
}
